// Portal.jsx — thin wrapper for ReactDOM.createPortal so modal overlays render at
// document.body, immune to ancestor CSS (transforms, filters, position:relative, overflow).
import React from 'react';
import ReactDOM from 'react-dom';

export default function Portal({ children, containerId = 'tm-portal-root' }) {
  const [node] = React.useState(() => {
    if (typeof document === 'undefined') return null;
    let el = document.getElementById(containerId);
    if (!el) {
      el = document.createElement('div');
      el.id = containerId;
      document.body.appendChild(el);
    }
    return el;
  });
  if (!node) return null;
  return ReactDOM.createPortal(children, node);
}
